import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

interface SaveFilterModalProps {
  show: boolean;
  onHide: () => void;
  onSave: (name: string) => void;
  existingName?: string;
}

export const SaveFilterModal: React.FC<SaveFilterModalProps> = ({
  show,
  onHide,
  onSave,
  existingName = ''
}) => {
  const [filterName, setFilterName] = useState(existingName);

  React.useEffect(() => {
    if (show) {
      setFilterName(existingName);
    }
  }, [show, existingName]);

  const handleSave = () => {
    if (filterName.trim()) {
      onSave(filterName.trim());
      setFilterName('');
      onHide();
    }
  };

  const handleClose = () => {
    setFilterName(existingName);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Uložiť filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label className="form-label">Názov filtra</label>
          <input
            type="text"
            className="form-control"
            value={filterName}
            onChange={(e) => setFilterName(e.target.value)}
            placeholder="Zadajte názov filtra..."
            autoFocus
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSave();
              }
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handleClose}>
          Zrušiť
        </button>
        <button
          className="btn btn-primary"
          onClick={handleSave}
          disabled={!filterName.trim()}
        >
          Uložiť
        </button>
      </Modal.Footer>
    </Modal>
  );
};
